import { Component, Inject, OnInit, OnDestroy, ChangeDetectorRef} from '@angular/core';
import _ from 'lodash';
import {moment} from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import  Chart from 'chart.js';

import { MySynchDataStore } from "../../data-stores/mysynch.datastore";
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { MySynchFormatterService } from '../../services/mysynch-formatter.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceContext} from '../../interfaces/mysynch.interfaces';


interface Time{
    current:string;
    options:string[];
};
interface PreviousPrefixes{
    PRIOR:string;
    LASTYEAR:string;
};
interface TimePrefixes{
    previousPrefixes: PreviousPrefixes;
    previousPrefix:string;
};
interface DefaultConstraintCodes {
    selection:string;
    time: Time
}


interface SelectionConstraint{
    selectionConstraintTypeId:number;
    name:string;
}

interface Constraints{
    selection?:SelectionConstraint;
    time:TimePrefixes;
}

interface Inputs{
    timeConstraintCode:string;
    previousPrefix:string;
}

@Component({
  standalone: false,
  selector: 'kpi-dashboard',
  templateUrl: '../app/pages/kpi-dashboard/kpi-dashboard.view.html',
  styleUrls:['../app/pages/kpi-dashboard/kpi-dashboard.style.css']
})
export class KpiDashboard implements OnInit , OnDestroy {

    private performanceContext: PerformanceContext | null = null;
    private EXCLUDED_LINEITEMS:string[] = [
        'REQUIREDPREGCOUNT',
        'ENTERCOUNT',
        'CHERRYPICKED',
        'REVENUECOWSALES',
        'REVENUEOTHERSALES',
        'MILKBLENDPRICE',
        'FIRSTSERVICEINSEMINATIONRATE',
        'SECONDSERVICEINSEMINATIONRATE',
        'INSEMINATIONINTERVAL'
    ];

    private loading:boolean = true;
    private chartColorsByLactGrp:any[] = [];
    private dateFormat:string = "";
    private filteredReportData:any[] = [];
    private reportDates:any[] = [];
    private chartTopics:any[] = [];
    private fixedDecimalSpaces:number = 2;
    private maxCharts:number = 4;
    private charts:any[] = [];

    private defaultTimeConstraintId = 12; // month
    private defaultConstraintCodes: DefaultConstraintCodes = {
        selection: 'ALL',
        time: {
            current: 'MONTH',
            options: ['WEEK', '21DAY', 'MONTH', 'QUARTER']
        }
    };

    private constraints:Constraints = {
        selection: null,
        time: {
            previousPrefixes: {
                PRIOR:		'Previous',
                LASTYEAR:	'Last Year'
            },
            previousPrefix:	'PRIOR'
        }
    };
    
    private inputs:Inputs = {
        timeConstraintCode:	this.defaultConstraintCodes.time.current,
        previousPrefix:		this.constraints.time.previousPrefix
    };

    private filters:any[]	= [];
    private activeFarm:any = {};
    private mySynchState:any = {};

    private nonHeiferFilterOptions:any[] = [];
    
    reportSections:any[] = [];
    chartTimeLabels:any[] = ['Current', 'Current', 'Current', 'Current (previous 30 days)'];
    ungroupedData:any[] = [];
    groupedData:any = {};
    incompleteSetupMessage:string = '';
    chartTitles:any[] =  ['', '', '', ''];
    asOfDate:string = '';

    _ :any;

    // subscriptions and deregistration references
    private currentActiveHerdSubscription: any;

   
    constructor(@Inject(ChangeDetectorRef) private cdRef: ChangeDetectorRef,
                @Inject('MySynchFactory') private MSF:any,
                @Inject('ApiFactory') private api:any,
                @Inject(MySynchConstantService) private mySynchConstantService:MySynchConstantService,
                @Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
                @Inject(MySynchFormatterService) private mySynchFormatterService:MySynchFormatterService,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                @Inject(ClientLoggerService) private log:ClientLoggerService
                ){
                    this._ = _;
                }


    

    // $s.getIncompleteSetupMessages = function getIncompleteSetupMessages() {
    //     return $s.incompleteSetupMessage.split('|');
    // };

    // $s.getRhaDisplayValue = function getRhaDisplayValue(lineItems, returnUnits) {
    //     var lineItem = _.find(lineItems, {selectionConstraintTypeId: 9, timeConstraintTypeId: 1});

    //     return getDisplayValueForLineItem(lineItem, returnUnits, null);
    // };

    // private getVariance(items) {
    //     var itemsToCompare = [
    //         this.getFilteredLineItem(items, null),
    //         this.getFilteredLineItem(items, true)	//	previous
    //     ];

    //     var variance = {
    //         icon: 'fa-minus',
    //         color: 'text-primary',
    //         value: this.convertForDisplay(+(itemsToCompare[0].currentValue - itemsToCompare[1].currentValue), this.getFilteredLineItem(items,null), null)
    //     };

    //     if (variance.value > 0) {	//	value is positive
    //         variance.icon	= 'fa-arrow-up';
    //         variance.color	= itemsToCompare[0].isPositiveVarianceGood ? 'text-success'	: 'text-danger';
    //     } else if (variance.value) {	//	value is negative (not zero)
    //         variance.icon	= 'fa-arrow-down';
    //         variance.color	= itemsToCompare[0].isPositiveVarianceGood ? 'text-danger'	: 'text-success';
    //     }

    //     return variance;
    // };

    private latestDate(dateStrings) {
        return this._.max(dateStrings, (i) => {
            return moment(i);
        });
    }

    private localizeDate(dateString) {
        var d = moment(dateString);

        return d.subtract(d.utcOffset(), 'minutes');
    }
    


    private buildTimeLables(){
        this.chartTimeLabels = [];
        _.forEach(this.reportSections, (cfSection) => {
             var cfReportSectionCode = this._.get(cfSection,'code');
             var cfdateSelectionConstraintId = this._.get(cfSection,'selectionConstraintId',3);

             var sectionTimeLabel = this.getDateLabelForSection(cfReportSectionCode,cfdateSelectionConstraintId);

             this.chartTimeLabels.push(sectionTimeLabel);
        });
    }

    private getDateLabelForSection(reportSectionCode,dateSelectionConstraintId){
        var dateLabel = "";
        //var dateFormatString = MSF.i18n.format.date.replace(/-/g, '/');

        var cfReportSection = this._.find(this.reportSections,{code:reportSectionCode});
        
        var sectionItem = this._.find(this.filteredReportData,{reportSectionCode: reportSectionCode,selectionConstraintTypeId: dateSelectionConstraintId});
        var baseDate = this.localizeDate(this._.get(sectionItem, 'reportDate', this.latestDate(this.reportDates)));

        var firstDate = "";
        var endDate = "";

        if(this._.isEqual("future"),this._.get(cfReportSection,'dateRangeDirection')){
            firstDate = moment(baseDate).format(this.dateFormat);
            // we are subtracting 1 from the breedingPeriodInterval because we store the business rule of the value for a breeeding period in SQL , but we want to show a date range that exlcudes the start of the next breeding period
            var numDaysInFuture = this._.parseInt(this._.get(cfReportSection,'breedingPeriodInterval'))-1;
            endDate = moment(baseDate).add(numDaysInFuture, 'days').format(this.dateFormat);
        }else{
            endDate = moment(baseDate).format(this.dateFormat);
            // we are adding 1 from the breedingPeriodInterval because we store the business rule of the value for a breeeding period in SQL , but we want to show a date range that exlcudes the end of the previous breeding period
            var numDaysInPast = this._.parseInt(this._.get(cfReportSection,'breedingPeriodInterval'))+1;
            firstDate = moment(baseDate).subtract(numDaysInPast, 'days').format(this.dateFormat);
        }
        
        if(this._.get(cfReportSection,'showDataRange')){
            dateLabel = firstDate+" - "+endDate;
        }else{
            dateLabel = firstDate;
        }

        return dateLabel;
    }

    private getReportData() {
        return new Promise<void>((resolve, reject) => {
            this.loading = true;
            this.ungroupedData = [];
            this.incompleteSetupMessage = '';
            var currentHerd = this.MSF.getActiveHerd();

            if (!this._.isEmpty(currentHerd)) {
                this.perfMetricSvc.startTiming('Page:KpiDashboardPageData:Request');
                this.api.getReportDetailsByReportCodeAndHerdId({
                    reportCode: 'DASHBOARDCLASSIC',
                    herdId: currentHerd.herdId
                }, 
                this.performanceContext

                , (err, reportData) =>  {
                    this.loading = false;
                    this.perfMetricSvc.endTiming("page",'Page:KpiDashboardPageData:Request', this.performanceContext);

                    if (err) {
                        this.log.error(err);

                        if (reportData.statusCode === 403) { // 403 indicates setup is not complete and should have display message in response
                            this.incompleteSetupMessage = reportData.statusText;
                        }

                        resolve(err); // No report data to process as setup is incomplete
                    }
                    this.perfMetricSvc.startTiming('Page:KpiDashboard:Build');

                    this.filteredReportData = [];
                
                    this._.forEach(this.reportSections,(section) => {
                        var filteredReportDataBySection = this._.filter(reportData,{reportSectionCode: this._.get(section,'code')});
                        var sectionLineItemCodes = this._.pluck(this._.get(section,'lineItems',[]),'code');
                        var filteredReportDataBySectionAndLineItem = this._.filter(filteredReportDataBySection,(dataItem)=>{return this._.includes(sectionLineItemCodes,this._.get(dataItem,'reportLineItemCode'))});
                        this.filteredReportData = this._.union(this.filteredReportData,filteredReportDataBySectionAndLineItem);
                    });

                    // order the results by section
                    var orderedBySectionFilteredReportData = this._.sortBy(this.filteredReportData, 'rsSequence');

                    var orderedByLineItemReportData = [];
                    // All KPI report line items are returned even if currentValue is null. So if all of the records have a null currentValue , then we don't need to order the data.
                    if(!this._.all(orderedBySectionFilteredReportData,(dataItem)=>{return this._.isNull(this._.get(dataItem,'currentValue'))})){

                        this._.forEach(orderedBySectionFilteredReportData, (data) => {
                            
                            if (data.reportSectionName === this._.get(this._.find(this.MSF.lists.reportSection,{code:'KPI_HERD'}),'name') && data.timeConstraintTypeId === 1) {
                                data.currentValue = Math.ceil(data.currentValue);
                            }

                            if (data.reportLineItemCode === 'CALVINGINTERVAL') {
                                data.currentValue = data.currentValue === null ? null : data.currentValue / 30.5;
                            }

                            if (this._.contains(['MILKFAT', 'MILKPROTEIN', 'MILKUREANITROGEN'], data.reportLineItemCode)) {
                                data.currentValue = data.currentValue / 100;
                            }
                        });

                        orderedByLineItemReportData = _.sortBy(orderedBySectionFilteredReportData, 'rliSequence');
                    }
                    

                    this.ungroupedData = orderedByLineItemReportData;
                
                    // sections should be already ordered by their sequence before this point      
                    this._.forEach(this.reportSections,(section) => {
                        var sectionCode = this._.get(section,'code');
                        this._.set(this.groupedData,sectionCode,this._.filter(orderedByLineItemReportData,{reportSectionCode:sectionCode}));
                    }); 
            

                    this.reportDates = this._.sortBy(this._.uniq(this._.map(orderedByLineItemReportData, 'reportDate'))).reverse();

                    this.chartTopics = this._.map(this.groupedData, (items) => {
                        return this._.get(items, '[0].reportLineItemCode');
                    });

                    this.chartTitles = this._.map(this.groupedData, (items) => {
                        return this.getDisplayLabelLineItem(this._.get(items, '[0].reportLineItemName'));
                    });

                    this._.forOwn(this.groupedData, (dataArray, key) => {
                        this.groupedData[key] = this._.groupBy(dataArray, 'reportLineItemCode');
                    });
                    //----------------------------------------------------------------------------------------------------
                    //TODO:HC For User Story 6710. Refactor the following Technical Debt at a later time. 
                    // hardcoding a new line item for Milk Fat to Protein Ratio into the Average Daily Milk list/chart
                    // but should refactor this into its own entries in the HRLI Table and tie it in with the Azure functions
                    var milkFatLineItems = this._.get(this.groupedData,'KPI_REVENUE.MILKFAT');
                    var milkProteinLineItems = this._.get(this.groupedData,'KPI_REVENUE.MILKPROTEIN');
                    var milkFatToProteinLineItems = [];
                    
                    this._.forEach(milkFatLineItems, (lineItem,milkFatLineItemIndex) =>{
                            var milkFatValue = this._.get(lineItem,'currentValue');
                            var milkProteinValue = this._.get(milkProteinLineItems[milkFatLineItemIndex],'currentValue');

                            var selectionConstraintTypeId = 9;

                            switch(milkFatLineItemIndex){
                                case 0: 
                                selectionConstraintTypeId = 2;
                                break;
                                case 1: 
                                selectionConstraintTypeId = 3;
                                break;
                                case 2:
                                selectionConstraintTypeId = 9;
                                break;
                            }

                            var milkFatToProteinLineItem = {
                                reportSectionCode: 'KPI_REVENUE',
                                reportLineItemCode : 'MILKFATTOPROTEIN',
                                reportLineItemName : "Milk Fat to Protein Ratio",
                                reportSectionName: "Milk Production",
                                currentValue: (milkFatValue / milkProteinValue),
                                selectionConstraintTypeId: selectionConstraintTypeId, 
                                timeConstraintTypeId: 13, // MONTH
                                unitTypeId: 29, // precision 2 decimal
                                displayOrder: 33,
                                decimalSpaces: 2,
                                rliSequence:4
                            };
                            milkFatToProteinLineItems.push(milkFatToProteinLineItem);
                            this.ungroupedData.push(milkFatToProteinLineItem);
                            this.filteredReportData.push(milkFatToProteinLineItem);
                    });
                    this._.set(this.groupedData,'KPI_REVENUE.MILKFATTOPROTEIN',milkFatToProteinLineItems);
                    
                    // need to first ungroup the data to properly order by displayOrder again then by reportLineItemName to get correct order in a cleaner way
                    
                    var updatedUngroupedKPIRevenueData = [];
                    this._.forEach(this.groupedData.KPI_REVENUE, (lineItemGroup) =>{
                        updatedUngroupedKPIRevenueData = updatedUngroupedKPIRevenueData.concat(lineItemGroup); 
                    });
                    
                    var updatedOrderedKPIRevenueData = this._.sortByOrder(updatedUngroupedKPIRevenueData, ['rliSequence','reportLineItemName']);
                    var updatedGroupedKPIRevenueData = this._.groupBy(updatedOrderedKPIRevenueData, 'reportLineItemCode');
                    this.groupedData.KPI_REVENUE = updatedGroupedKPIRevenueData;
                    
                    //----------------------------------------------------------------------------------------------------
                    try {
                        var dateFormatString = this.MSF.i18n.format.date.replace(/-/g, '/');


                    
                        // latest date of anything is the as-of base date
                        var herdSectionItem = this._.find(this.filteredReportData, {reportSectionName: this._.get(this._.find(this.MSF.lists.reportSection,{code:'KPI_HERD'}),'name')});
                        var baseDate = this.localizeDate(this._.get(herdSectionItem, 'reportDate', this.latestDate(this.reportDates)));
                    
                        // ui bindings
                        
                        var currentActiveHerdId = this._.get(this.MSF.getActiveHerd(), 'herdId');
                        var currentActiveHerdAdditionalHerdData = this.MSF.getAdditionalHerdDataItem(currentActiveHerdId);
                        var metaLastEventDateString = this._.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
                    
                        var longDateFormat = this.MSF.getLongDateFormatFromMetaFormatString(this.dateFormat,"/");
                        this.asOfDate = !this._.isUndefined(metaLastEventDateString)?moment(metaLastEventDateString).format(longDateFormat) : ""; //baseDate.format(MSF.i18n.format.dateLong);
                        this.buildTimeLables();
                        
                    }

                    catch (e) {
                        this.log.warn('unable to format data availability dates');
                    }

                    this.updateCharts(undefined);
                    this.perfMetricSvc.endTiming("page",'Page:KpiDashboard:Build', this.performanceContext);
                    this.loading = false;
                    resolve();
                });
            }else{
                resolve();
            }
      });
    }

    private getDisplayLabelLineItem(lineItemName){
        var displayLabel = lineItemName;
        if(this._.includes(lineItemName,'(lbs.)') || this._.includes(lineItemName,'(kg)')){

            var measurementStandardUnit = this.getMeasurementStandardUnitDisplay('weight');
            
            var firstHalfLineItemNameParts = lineItemName.split('(')
            var firstHalfLineItemName = this._.get(firstHalfLineItemNameParts,'[0]');
            var secondHalfLineItemNameParts = this._.get(firstHalfLineItemNameParts,"[1]").split(')');
            var secondHalfLineItemName = this._.get(secondHalfLineItemNameParts,'[1]');

            displayLabel = firstHalfLineItemName+"("+measurementStandardUnit+")"+secondHalfLineItemName;
        }

        return displayLabel;
    }

    private getDisplayLabelForFilteredLineItem(lineItems){
        var lineItem = this.getFilteredLineItem(lineItems);
        
        var lineItemName = this._.get(lineItem,'reportLineItemName');
        
        var displayLabel = this.getDisplayLabelLineItem(lineItemName);
        
        return displayLabel;
            
    }
    

    private  convertForDisplay(value, lineItem){

        if(this._.isNull(value) || this._.isUndefined(value)){
            return "";
        }

        value = Number(value || 0);
        
        let formattedValue = '';
        let lineItemReportLineItemCode = this._.get(lineItem,'reportLineItemCode');

       // Currently the metricCodes are the same value as the reportLineItemCode
        formattedValue = this.mySynchFormatterService.formatMetricNumberValue(value, lineItemReportLineItemCode);
          

        return formattedValue;
        
    }

    private  getChartBarColors(lineItemCode){
       
        //var selConstIds = this._.pluck(this._.sortBy(this._.filter(this.ungroupedData,{reportLineItemCode:lineItemCode}),'selectionConstraintTypeId'),'selectionConstraintTypeId');
        let selConstIds = this._.map(this.selectionConstraintsPossiblyWithoutHeifers(lineItemCode),'selectionConstraintTypeId');
        var colorsByLactGrp = this._.map(selConstIds, (selConstId) => {
                                  return this._.get(this._.find(this.chartColorsByLactGrp,{selectionConstraintTypeId: selConstId}),'color')
                              });

        
        return colorsByLactGrp;
    } 

    private  selectionConstraintsPossiblyWithoutHeifers(topic) {
                    
        var reportSectionLineItemSelectionConstraints = [];
        var reportSectionLineItem = this._.find(this._.flatten(this._.pluck(this.reportSections,"lineItems")) , { code: topic});
        this._.forEach(this.MSF.lists.selectionConstraintType, (selectionConstraint) => {
            if(this._.includes(this._.get(reportSectionLineItem,'selectionConstraintCodes'),this._.get(selectionConstraint,"code"))){
                reportSectionLineItemSelectionConstraints.push(selectionConstraint);
            }
        });
        
        if(this._.isEmpty(reportSectionLineItemSelectionConstraints)){
            reportSectionLineItemSelectionConstraints =  this._.cloneDeep(this.MSF.lists.selectionConstraintType);
        }
        return reportSectionLineItemSelectionConstraints;

    }

    private updateCharts(index) {
        setTimeout( () => {
            var chartTopicsToUpdate	= this.chartTopics;
            var chartUpdateIndexes	= [0, 1, 2, 3];

            if (typeof index !== 'undefined') {
                chartTopicsToUpdate = [this.chartTopics[index]];

                if (this.charts.length >= index) {
                    this.charts[index].destroy();
                    chartUpdateIndexes = [index];
                }
            } else {
                this._.forEach(this.charts, (chart) => {
                    chart.destroy();
                });
            }

            this._.forEach(chartTopicsToUpdate, (topic, index) => {
                

                //var includeRhaValues = _.includes(_.keys($s.groupedData.KPI_FERTILITY_PERIOD), topic);
                var includeRhaValues = !this._.isUndefined(this._.find(this._.filter(this.ungroupedData,{reportLineItemCode: topic}),{timeConstraintTypeId: 1}));
                var jqChartElement = $('#kpi-chart-' + chartUpdateIndexes[index])[0] as HTMLCanvasElement;

                if (!jqChartElement) {
                    return false;
                }

                //	Rolling Herd Average (last column)
                var rha = {
                    text: 'RHA',
                    code: '12MONTHRA'
                };
               
                var data = this._.map(this._.filter(this._.filter(this._.sortBy(this.ungroupedData, 'selectionConstraintTypeId'), {
                    reportLineItemCode: topic,
                    //timeConstraintTypeId: this._.find(this.MSF.lists.timeConstraintType, {code: this.inputs.timeConstraintCode}).timeConstraintTypeId
                }), (data) => {
                    return this._.includes(this._.map(this.selectionConstraintsPossiblyWithoutHeifers(topic), 'selectionConstraintTypeId'), data.selectionConstraintTypeId);
                }), 'currentValue');

                if (includeRhaValues) {
                    data = data
                    .concat(this._.map(this._.where(this.ungroupedData, {
                        reportLineItemCode: topic,
                        timeConstraintTypeId: this._.find(this.MSF.lists.timeConstraintType, {code: rha.code}).timeConstraintTypeId,
                        selectionConstraintTypeId: this._.find(this.selectionConstraintsPossiblyWithoutHeifers(topic), {
                            code: this.defaultConstraintCodes.selection
                        }).selectionConstraintTypeId
                    }), 'currentValue'));
                }

                var labels = this._.map(this.selectionConstraintsPossiblyWithoutHeifers(topic), 'name');

                if (includeRhaValues) {
                    labels = labels.concat(rha.text);
                }

                var barColors = this.MSF.colorComponents.slice();

                // if the first column isnt there, shift the colors over
                if (!this._.contains(labels, 'Heifer')) {
                    barColors.shift();
                }

                var chartData = {
                    labels:	labels,
                    datasets: [{
                        label: topic,
                        data: data,
                        backgroundColor:	this.getChartBarColors(topic),
                        borderColor:		this.getChartBarColors(topic),
                        borderWidth: 1
                    }]
                };

                var chartLineItem	= this._.find(this.ungroupedData, {reportLineItemCode: topic});
                var hasFractions	= this._.any(this._.get(chartData, 'datasets[0].data', []), (i) => {
                    return i !== null && i !== Math.floor(i);
                });
                var scaleDecimalSpaces = 0;

                if (topic === 'SERVICESPERPREGNANCY' && hasFractions) {
                    scaleDecimalSpaces = 1;
                }

                var stepSize;
                var max;
                var highestValue = this._.get(this._.max(this._.filter(this.ungroupedData, {reportLineItemCode: topic}), 'currentValue'), 'currentValue', 0);

                if (chartLineItem && this._.get(this._.find(this.MSF.lists.unitType, {unitTypeId: chartLineItem.unitTypeId}), 'code') === 'PCT') {
                    // percentage type fields should always show a chart from 0 to 100
                       
                    // max			= 1;
                       max = (highestValue < 0.1) ? (Math.ceil((highestValue*100)) + 1) / 100 : Math.ceil((highestValue*10)) / 10;
                       if(max <= 0.20){
                           
                           if(max <= 0.1){
                            stepSize =0.005;
                            scaleDecimalSpaces = 1;
                           }else{
                            stepSize =0.02;
                            scaleDecimalSpaces = 0;
                           }
                          
                          
                       }else{
                         stepSize = 0.1
                       }
                    
                } else {

                    if (highestValue < 5) {
                        max			= Math.ceil(highestValue)//5;
                        stepSize	= 0.2;
                        scaleDecimalSpaces = 1;
                    } else if (highestValue < 10) {
                        max			= 10;
                        stepSize	= 1;
                    }
                }

                var chartOptions = {
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: [{
                            ticks: {
                                autoSkip: false
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                autoSkip:		false,
                                beginAtZero:	true,
                                callback: (value) => {
                                    var cfUnitType = this._.find(this.MSF.lists.unitType, {unitTypeId: this._.get(chartLineItem, 'unitTypeId')});
                                    var cfUnitTypeCode = this._.get(cfUnitType,'code',"");
                                    value = value === 1 && this._.isEqual(cfUnitTypeCode,'PCT') ? 100 : value;   
                                    return ' ' + this.convertForDisplay(value, chartLineItem);
                                },
                                stepSize:		stepSize,
                                max:			max
                            }
                        }]
                    },
                    tooltips: {
                        titleFontSize:		0,
                        titleSpace:			0,
                        titleMarginBottom:	0,
                        bodyFontSize:		14,
                        callbacks: {
                            label: (valuePayload) => {
                                return (valuePayload.xLabel ? valuePayload.xLabel + ': ' : '') + this.convertForDisplay(valuePayload.yLabel, chartLineItem);
                            }
                        }
                    }
                };
                //TODO: upgrade charts.js from 2.x to 3.x then to 4.x
                this.charts[chartUpdateIndexes[index]] = new Chart(jqChartElement, {
                    type:		'bar',
                    data:		chartData,
                    options:	chartOptions
                });
            });
        }, 0);
    };

    private getMeasurementStandardUnitDisplay(measurementType){
      
        var measurementUnit = "";
        // replace any measurement standard text 
        var activeFarmMeasurementStandard = this._.get(this.activeFarm,'measurementStandard',"");

         measurementUnit = this.MSF.getMeasurementStandardUnitByMeasurementType(activeFarmMeasurementStandard,measurementType);
         
        return measurementUnit; 

    };

    private getFilteredTimeConstraints() {
        return this._.filter(this.MSF.lists.timeConstraintType, (timeConstraint) => {
            return this._.includes(this.defaultConstraintCodes.time.options, timeConstraint.code);
        });
    };


    private getFilterOptions(index){
        return (index > 0) ? this.nonHeiferFilterOptions : this.MSF.lists.selectionConstraintType;
    };

    private setSelectionConstraint(newSelectionConstraint) {
        this.constraints.selection = newSelectionConstraint;
    };

    private getDisplayValueForLineItem(lineItem, returnUnits) {
        var fullValue			= this.convertForDisplay(this._.get(lineItem, 'currentValue'), lineItem) + '';	
        return fullValue;
   };

    lineItemsHaveNoValues(lineItems) {
        return this._.all(lineItems, (lineItem) => {
            return !this.MSF.hasValue(this._.get(lineItem, 'currentValue'));
        });
    }
    
    setupIsIncomplete() {
        return this.incompleteSetupMessage !== '';
    };
    
    originalOrderCompare = (): number => {
        return 0;
    };
      

    getReportSectionName = (section)=>{
        var reportSectionName = "";
        
        var foundReportSectionName = this._.get( _.find(section,(sectionItems)=>{
                                                 return this._.find(sectionItems,(sectionItem)=>{
                                                                 return  !this._.isUndefined(this._.get(sectionItem,'reportSectionName'));
                                                             });
                                             })
                                           , '[0].reportSectionName');
        if(!this._.isUndefined(foundReportSectionName)){
            reportSectionName = foundReportSectionName;
        }

        return reportSectionName;
    };
    

    isChartActive(lineItem) {
        return this._.contains(this.chartTopics, this._.get(lineItem, 'reportLineItemCode'));
    };

    getFilteredLineItem(lineItems) {
        var timeConstraintTypeId     = _.get(lineItems,'[0].timeConstraintTypeId', this.defaultTimeConstraintId);
        //var timeConstraint			= this._.find(this.MSF.lists.timeConstraintType, {timeConstraintId: timeConstraintId});
        var selectionConstraintTypeId	= this.constraints.selection.selectionConstraintTypeId;

        if (lineItems.length) {
            var sectionIndex =     this._.indexOf(this.reportSections,this._.find(this.reportSections,{code: lineItems[0].reportSectionCode}));


            if (sectionIndex > -1) {
                var sectionFilter = this._.get(this.filters, '[' + sectionIndex + ']', null);

                if (sectionFilter) {
                    selectionConstraintTypeId = sectionFilter.selectionConstraintTypeId;
                }
            }
        }
        
        // if all the currentValues in lineItems are null, then just return the first one to get the name of the lineItem for display
        if(lineItems.length > 0 && this.lineItemsHaveNoValues(lineItems)){
            return _.get(lineItems,'[0]');
        }

        var filteredItems = this._.filter(lineItems, {
            selectionConstraintTypeId: selectionConstraintTypeId
        });

        //return this._.find(filteredItems, {timeConstraintTypeId: timeConstraint.timeConstraintTypeId});
        return this._.find(filteredItems, {timeConstraintTypeId: timeConstraintTypeId});
    };
    
    getReportDisplayValue(lineItems, returnUnits) {
        var lineItem = this.getFilteredLineItem(lineItems);

        return this.getDisplayValueForLineItem(lineItem, returnUnits);
    };


    addChartTopic(lineItem) {
        if (!lineItem) {
            return;
        }

        var chartTopic	= lineItem.reportLineItemCode;
        var chartTitle	= this.getDisplayLabelLineItem(lineItem.reportLineItemName);
        var section		= lineItem.reportSectionCode;
        var chartIndex	= this._.keys(this.groupedData).indexOf(section);

        this.chartTopics[chartIndex] = chartTopic;
        this.chartTitles[chartIndex] = chartTitle;
        this.updateCharts(chartIndex);
    };

    ngOnDestroy(): void {
        if (this.currentActiveHerdSubscription) {
            this.currentActiveHerdSubscription.unsubscribe();
        }

        
        this.performanceContext = null;

        const chartsToDestroy = this.charts?.slice() || [];
        this.charts = null;

        for (const chart of chartsToDestroy) {
            if (!chart) continue;

            try {
                // Kill hidden resize monitor div
                const monitor = chart.canvas?.parentNode?.querySelector('.chartjs-size-monitor');
                monitor?.remove();

                // Destroy Chart instance and internal bindings
                chart.destroy();

                // Remove DOM canvas node
                chart.canvas?.remove();

                // Null all Chart object references
                chart.canvas = null;
                chart.ctx = null;
                chart.config = null;
                chart.scales = null;
                chart.$context = null;
                if (chart.chartArea) {
                    chart.chartArea = null;
                }

            } catch (e) {
                console.warn('Chart cleanup failed:', e);
            }
        }

        // Remove any jQuery-bound handlers (if any were used)
        $('[id^="kpi-chart-"]').off();

        // Detach change detection if needed
        try {
            this.cdRef?.detach?.();
        } catch (e) {
            console.log('KpiDashboard: cdRef.detach failed', e);
        }

    }

    ngOnInit() {
    
        this.MSF.ready( () => {
            
            
            // report sections with line items to be displayed
            var kpiHRLIReportCodeFile = this._.find(this.MSF.lists.codeFile,{codeType:'HRLIREPORTS',code:'KPIDASHBOARD'});
            var kpiHRLIReportDetailsJSONObj = {}
            try {
                kpiHRLIReportDetailsJSONObj = JSON.parse(this._.get(kpiHRLIReportCodeFile,'detailsJson'))[0];
                this.reportSections = this._.get(kpiHRLIReportDetailsJSONObj,'reportSections');
                this._.forEach(this.reportSections, (section) => {
                        // sequence
                        this._.set(section,'sequence',this._.get(this._.find(this.MSF.lists.reportSection,{code:this._.get(section,'code')}),'sequence'));
                });
                this.reportSections = this._.sortBy(this.reportSections,'sequence');
            }catch(e){
                console.log("Failed to parse KPI Dashboard code file entry's details json")
            }

            // chart colors
            this._.forEach(this._.filter(this.MSF.lists.codeFile,{codeType: 'CHARTCOLORSBYLACTGRP'}), (cfLactGrp) => {
                let chartColorsByLactGrpItem = {selectionConstraintTypeId: 0,lactGrp: "",color:""};
                let cfCode = this._.get(cfLactGrp,'code');
                this._.set(chartColorsByLactGrpItem,'lactGrp',cfCode);
                this._.set(chartColorsByLactGrpItem,'color',this._.get(cfLactGrp,'codeValue'));

                let cfSelectionConstraintType = this._.find(this.MSF.lists.selectionConstraintType,{code: cfCode});
                this._.set(chartColorsByLactGrpItem,'selectionConstraintTypeId',this._.get(cfSelectionConstraintType,'selectionConstraintTypeId'));
                this.chartColorsByLactGrp.push(chartColorsByLactGrpItem);
            });


            this.constraints.selection	= this._.find(this.MSF.lists.selectionConstraintType, {code: this.defaultConstraintCodes.selection});
            this.nonHeiferFilterOptions		= this.MSF.lists.selectionConstraintType.slice(1);
            this.nonHeiferFilterOptions[2]	= this._.extend({}, this.nonHeiferFilterOptions[2], {name: 'Entire Herd (excluding heifers)'});
            
            this._.forEach(this.reportSections, (section,index) => {
                this.filters[index] = this._.find(this.MSF.lists.selectionConstraintType,	{code: 'ALL'});
            });

            //local storage data 	
            let mySynchStateJSON = localStorage.getItem('MySynch-state');
            if(!this._.isUndefined(mySynchStateJSON)){
                this.mySynchState = JSON.parse(mySynchStateJSON);

                this.activeFarm = this._.get(this.mySynchState,'value.activeFarm',{});
            }
            this.dateFormat = this.MSF.getActiveHerdTimeFormatWithLongDigitYear();

            this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(this.MSF.getActiveHerd(),'herdId', null));
            this.perfMetricSvc.startTiming('Page:KpiDashboard:Render');
            this.getReportData().then((result) => {
                this.perfMetricSvc.markPageReady('Page:KpiDashboard:Render', this.performanceContext);
            });

            this.currentActiveHerdSubscription = this.mysynchDataStore.currentActiveHerd.subscribe((activeHerd) => {
                if(!this._.isUndefined(activeHerd) && this.loading === false){
                    console.log("KpiDashboard: Herd changed, reloading report data");
                    // ungroupedData is tied to when the report loading data message + spinner shows
                    this.ungroupedData = [];
                        //local storage data 	
                    let mySynchStateJSON = localStorage.getItem('MySynch-state');
                    if(!this._.isUndefined(mySynchStateJSON)){
                        this.mySynchState = JSON.parse(mySynchStateJSON);

                        this.activeFarm = this._.get(this.mySynchState,'value.activeFarm',{});
                    }
                    
                    this.dateFormat = this.MSF.getActiveHerdTimeFormatWithLongDigitYear();
                    this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(this.MSF.getActiveHerd(),'herdId', null));
                    this.perfMetricSvc.startTiming('Page:KpiDashboard:RenderOnHerdChange');
                    this.getReportData().then((result) => {
                        this.perfMetricSvc.markPageReady('Page:KpiDashboard:RenderOnHerdChange', this.performanceContext);
                    });

                }else{
                    console.log("KpiDashboard: Herd changed, but loading is already in progress, skipping reload");
                }
            });
        });
    }


}